export default __webpack_public_path__ + "static/media/dog--product--background.b819da5f.png";